export const AddElementBiOrigin = 'site-segment-add-element_layers-panel';

export const AUTOMATION_IDS = {
  EMPTY_STATE: {
    CONTAINER: 'empty-state-node',
    ADD_ELEMENT: 'empty-state-node-cta',
  },
};
